import { SquareFilled } from '@fluentui/react-icons';
import { PROJECT_STATUS_METADATA } from '../constants';
import { EProjectStatus } from '../types';

type TProps = {
  status: EProjectStatus;
  size?: 'default' | 'small' | 'medium';
};

// Colors come from PROJECT_STATUS_METADATA so the square always matches the status badge's hue.
const ProjectStatusIcon = ({ status, size = 'default' }: TProps) => {
  const fontSize = size === 'small' ? 16 : size === 'medium' ? 20 : undefined;
  const color = PROJECT_STATUS_METADATA[status].squareColor;

  return <SquareFilled color={color} fontSize={fontSize} />;
};

export default ProjectStatusIcon;
